export default {"src":"/_next/static/media/facebook.3026d123.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};